import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { t } from '../../translations/translations';
import { WHO_ITS_FOR } from '../../data/mock';

export const AudienceSection = () => {
  const { language } = useLanguage();

  return (
    <section className="py-20 bg-[#f5f2e8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-medium text-gray-900 mb-4">{t(language, 'sections.builtFor')}</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {WHO_ITS_FOR.map((audience) => {
            const Icon = LucideIcons[audience.icon];
            return (
              <div key={audience.key} className="bg-white p-6 rounded-lg border border-gray-200 hover:border-blue-900 transition-all duration-300">
                <Icon className="w-10 h-10 text-blue-900 mb-4" />
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{t(language, `audience.${audience.key}`)}</h3>
                <p className="text-gray-600">{t(language, `audience.${audience.key}Desc`)}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
